import axios from "axios";
import { getBackendApiUrl } from "../config";

const api = axios.create({
	baseURL: getBackendApiUrl(),
	withCredentials: true,
});

export default api;
